export default {
  common: {
    appname: 'FFMembers',
    signup: 'Sign Up',
    signin: 'Sign In',
    save: 'Save',
    update: 'Update',
    ok: 'OK',
    cancel: 'Cancel',
    agree: 'Agree',
    disagree: 'Disagree',
    confirm: 'Confirm',
    select: 'Select',
    send: 'Send',
    delete: 'Delete',
    next: 'Next',
    copyright: '2020 AIVICK Co., Ltd. All rights reserved.',
  },
}
